import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'

import DineroPropShape from '~/utils/propTypes/dinero'

import DrawerFieldItem from './DrawerFieldItem'
import DrawerSection from './DrawerSection'

const PaymentDetailsSection = ({
  netPaymentAmount,
  grossPaymentAmount,
  paymentReference,
}) => {
  const {t} = useTranslation('pointsOnPayments')

  return (
    <DrawerSection
      title={t('pointsOnPayments:pointsOnPayment.drawer.paymentSectionTitle')}
    >
      <DrawerFieldItem
        label={t(
          'pointsOnPayments:pointsOnPayment.drawer.fields.paymentAmount',
        )}
        value={netPaymentAmount.toFormat()}
      />
      <DrawerFieldItem
        label={t('pointsOnPayments:pointsOnPayment.drawer.fields.feeAmount')}
        value={grossPaymentAmount.subtract(netPaymentAmount).toFormat()}
      />
      <DrawerFieldItem
        label={t(
          'pointsOnPayments:pointsOnPayment.drawer.fields.grossPaymentAmount',
        )}
        value={grossPaymentAmount.toFormat()}
      />
      <DrawerFieldItem
        label={t('pointsOnPayments:pointsOnPayment.drawer.fields.reference')}
        value={paymentReference}
      />
    </DrawerSection>
  )
}

PaymentDetailsSection.propTypes = {
  netPaymentAmount: DineroPropShape.isRequired,
  grossPaymentAmount: DineroPropShape.isRequired,
  paymentReference: PropTypes.string.isRequired,
}

export default PaymentDetailsSection
